//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Pagination from '~/components/Pagination.vue';
import Filters from './StatisticsTradersFilters.vue';
import User from '~/components/User.vue';
import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    Pagination,
    User,
  },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapState('statisticsTraders', ['data', 'page', 'pages']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsTraders', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
    }),

    async applyFilters() {
      try {
        this.setGeneralLoader(true);
        await this.loadDataAction();
        this.setGeneralLoader(false);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
    },

    setPage(value) {
      this.setPageAction(value);
      this.loadDataAction();
    },
  },
};
